import styled from "styled-components";

export const Container = styled.div`
  width: 50%;
  justify-content: center;
  margin: auto;
  align-items: center;
  margin-top: 3rem;
  margin-bottom: 8rem;
  font-family: "Poppins", sans-serif;
  h1 {
    text-align: center;
  }

  @media (max-width: 999px) {
    width: 99%;
  }
`;
